export default __webpack_public_path__ + "static/media/health_plan_brochure_sbc.225da638.pdf";